import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Crypto Guard - Restricts access to crypto-related routes
 * 
 * This guard checks if the user has crypto enabled (isCryptoEnabled).
 * If not enabled, the user is redirected to the dashboard.
 * 
 * Usage in routes:
 * {
 *   path: 'crypto',
 *   component: CryptoComponent,
 *   canActivate: [cryptoGuard]
 * }
 */
export const cryptoGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isCryptoEnabled()) {
        return true;
    }

    // If crypto is not enabled, redirect to dashboard
    router.navigate(['/dashboard']);
    return false;
};
